import script from "./RegisterStudyConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterStudyConsent.vue?vue&type=script&setup=true&lang=js"

import "./RegisterStudyConsent.vue?vue&type=style&index=0&id=69bc84c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bc84c0"]])

export default __exports__